module.exports = __webpack_public_path__ + "static/Exo_Diagram_Part03_sprite-90-fcef1c4505d34a75ffbe75decee8d831.png";